import { useEffect, useRef, useState } from "react";

export const useLoadAudio = ({ uri }: { uri: string }) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [audioHasLoad, setAudioHasLoad] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [position, setPosition] = useState(0);
  const [duration, setDuration] = useState(1);

  useEffect(() => {
    setLoading(true);
    const audio = new Audio(uri);
    audioRef.current = audio;

    const handleLoadedMetadata = () => {
      setDuration(audio.duration * 1000); // Convertimos a ms
      setAudioHasLoad(true);
      setLoading(false);
    };

    const handleTimeUpdate = () => {
      setPosition(audio.currentTime * 1000); // Convertimos a ms
    };

    const handlePlay = () => setIsPlaying(true);
    const handlePause = () => setIsPlaying(false);
    const handleEnded = () => setIsPlaying(false);

    audio.addEventListener("loadedmetadata", handleLoadedMetadata);
    audio.addEventListener("timeupdate", handleTimeUpdate);
    audio.addEventListener("play", handlePlay);
    audio.addEventListener("pause", handlePause);
    audio.addEventListener("ended", handleEnded);

    return () => {
      audio.pause();
      audio.src = "";
      audio.load();
      setAudioHasLoad(false);
    };
  }, [uri]);

  return {
    audio: audioRef.current,
    audioRef: audioRef,
    isPlaying,
    audioHasLoad,
    loading,
    position,
    duration,
  };
};